export const appEnvs = {
  REACT_APP_GITHUB_USERNAME: process.env.REACT_APP_GITHUB_USERNAME,
};
